module.exports = __webpack_public_path__ + "img/logo2.7c759ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blueoak/logo2.png
// module id = KdSH
// module chunks = 83